import { Box } from '@mui/material';
import { styles } from './styles';

type DashboardWrapperProps = React.ComponentPropsWithoutRef<'main'>;

export const DashboardWrapper = ({ children, ...props }: DashboardWrapperProps) => {
  return (
    <Box component="main" {...props} sx={styles.dashboardWrapper}>
      {children}
    </Box>
  );
};
